import { makeStyles } from 'tss-react/mui';

import { isLightTheme } from 'uiKit/Theme/themeUtils';

const name = 'PrivateChainCardActions';

export const usePrivateChainCardActionsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
  },
  copyEndpointButton: {
    minWidth: 'auto',
    minHeight: 30,
    height: 30,
    width: 32,
  },
  largeButton: {
    width: 'auto',
    whiteSpace: 'nowrap',
  },
  addNetworkButton: {
    width: 'auto',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: 'none',
    border: 'none',
    height: 40,
    whiteSpace: 'nowrap',
    fontSize: 16,
    '&:hover': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.grey[100],
    },
  },
  moreButton: {
    minWidth: 'auto',
    padding: 0,
    height: 32,
    width: 32,
    border: `2px solid ${isLightTheme(theme) ? '#F2F5FA' : '#1F2226'}`,
    borderRadius: 12,
    flexShrink: 0,

    svg: {
      width: 20,
      height: 20,
    },

    '&:hover': {
      borderColor: theme.palette.grey[100],
    },
  },
  moreButtonActive: {
    borderColor: theme.palette.grey[100],
  },
  moreButtonIcon: {
    '&&': {
      color: theme.palette.primary.main,
    },
  },
  menuPaper: {
    backgroundImage: 'none',
  },
  addToProjectButton: {
    '&:hover': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.grey[100],
    },
  },
  addToProjectButtonEmpty: {
    minWidth: 'auto',
    height: 30,
    minHeight: 30,
    width: 30,
    borderRadius: 11,
  },
  menuButtonPlaceholder: {
    width: 30,
  },
  menuButtonPlaceholderHidden: {
    display: 'none',
  },
}));
